import React, { useState, useEffect } from "react";

import { About } from "./about";
import { Services } from "./services";
import { Features } from "./features";
import { Team } from "./Team";
import { Gallery } from "./gallery";

import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { Slidershow } from "./slidershow";
import { LdServices } from "./ldserv";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Landing = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Slidershow />
      <About data={landingPageData.About} />
      <LdServices data={landingPageData.Services} />
      <Services data={landingPageData.Services2} />
      <Features data={landingPageData.Features} />
      <Team data={landingPageData.Team} />
      <Gallery data={landingPageData.Gallery} />
    </div>
  );
};

export default Landing;
